import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['burger', 'menu']

  initialize() {
    this.element.addEventListener('turbo:before-morph-attribute', (event) => {
      if (event.target === this.burgerTarget && this.burgerTarget.classList.contains('is-active')) {
        event.preventDefault()
      }
    })

    this.element.addEventListener('turbo:before-morph-attribute', (event) => {
      if (event.target === this.menuTarget && this.menuTarget.classList.contains('is-active')) {
        event.preventDefault()
      }
    })
  }

  toggle() {
    this.burgerTarget.classList.toggle('is-active')
    this.menuTarget.classList.toggle('is-active')
  }

  blur({currentTarget}) {
    currentTarget.blur()
  }
}
